import React from "react";
import { useEffect,useContext,useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../GlobalContext';
import { AppRefreshContext } from '../../AppRefresh';
import { methods } from '../../Validation';
import axios from 'axios';

import Select from "react-select";

import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";

import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


function convert24to12(time24) {
  let [hours, minutes] = time24.split(":").map(Number);

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // converts 0 → 12

  return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
}
const Body = () => {
  const { refreshApp } = useContext(AppRefreshContext);
   const { t, i18n } = useTranslation();
   const [startDate, setStartDate] = useState(null);
   const [endDate, setendDate] = useState(null);
   const [timezone_stus, settimezone_stus] = useState(true);
   const [selectedCity, setSelectedCity] = useState(null);
   const [selectedCountry, setSelectedCountry] = useState(null);

   const [starttime, setValue] = useState(null);
   const [endtime, setendValue] = useState(null);
const isSafari = true;
const [time, setTime] = useState(null);
const [timeend, setTime_end] = useState(null);
  const generateTimes = () => {
    const times = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hh = h.toString().padStart(2, "0");
        const mm = m.toString().padStart(2, "0");
        times.push({ value: `${hh}:${mm}`, label: convert24to12(`${hh}:${mm}`), name:"startTime" });
      }
    }
    return times;
  };

  const timeZone_nm_dt = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  

    const generateTimes_end = () => {
    const times = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hh = h.toString().padStart(2, "0");
        const mm = m.toString().padStart(2, "0");
        times.push({ value: `${hh}:${mm}`, label: convert24to12(`${hh}:${mm}`), name:"endTime" });
      }
    }
    return times;
  };

   const isValidDateRange = (fromDate, toDate) => {

  if (!fromDate || !toDate) return false;

  const from = parseYYYYMMDDToDate(fromDate);
  const to = parseYYYYMMDDToDate(toDate);

  if (!(from instanceof Date) || isNaN(from)) return false;
  if (!(to instanceof Date) || isNaN(to)) return false;

  return from.getTime() <= to.getTime();
};

  const timeOptions = generateTimes();
  const timeOptions_end = generateTimes_end();

   const loader = document.getElementById("loder-tive");
      const { default_country_detail } = useContext(GlobalContext);
           const { default_langage_details } = useContext(GlobalContext);

       const [showThanks,setSetshowThanks] = useState(true);
       
       const [errormsg,setErrormsg] = useState(null);
         let default_country_detail_data = null;
    let default_language_detail_data =null;
  if(localStorage.getItem('defult_country_details') != null){
    default_country_detail_data = JSON.parse(localStorage.getItem('defult_country_details'));
    default_language_detail_data = JSON.parse(localStorage.getItem('defult_language_details'));
  }

     console.log(default_country_detail_data);
        const parseYYYYMMDDToDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return null;

  const [y, m, d] = dateStr.split("-").map(Number);
  if (!y || !m || !d) return null;

  return new Date(y, m - 1, d);
};
   const formatDateYYYYMMDD = (date) => {
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

   const formatDateMMDDYYYY = (date) => {
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${day}-${month}-${year}`;
};
       const [formData, setFormData] = useState({
           fromDate: '',
       
            startTime: starttime,
           endTime: endDate,
           title: '',
           cost:'',
           cityId:'',
           address:'',
           countryId: localStorage.getItem('default_country_code'),
           languageField:default_langage_details.label,       
           campaignCode:''
   
         });


           const [formdata_valid_error,setFormDatavalid] = useState({//validName
                 fromDate: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('From_date_is_required')}],required:true,error:false,errormsg:null
                 },
                  cityId: {validtion:[{keyname:'required',methods:'requiredMethodsnot',parmeters:[],errormag:'The City field is required'}],required:false,error:false,errormsg:null
                                  },
                startTime: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The start Time field is required'}],required:false,error:false,errormsg:null
                                  },
                endTime: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The end Time field is required'}],required:false,error:false,errormsg:null
                                  },
                 title: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Title_is_required')}],required:true,error:false,errormsg:null},
                 cost:{validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Cost_is_required')},{keyname:'validnumber',methods:'validnumber',parmeters:[],errormag:t('Please_enter_numbers')}],required:true,error:false,errormsg:null},
                 address:{validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t("Address_is_required")}],required:true,error:false,errormsg:null},
               
                 campaignCode: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Campaign_code_is_required')}],required:true,error:false,errormsg:null},
         
               });
          const [loading, setLoading] = useState(true);
           const [error, setError] = useState(null);
   const [cityoptions, setOptionData] = useState([]);
   const [cityoptionsall, setOptionData_all] = useState([]);
   const [timeZones, setOptionDataZone] = useState([]);
      const [countryDetils_dt, setOptionDatacountryDetils] = useState([]);
       const { siteName } = useContext(GlobalContext);
       const { default_country } = useContext(GlobalContext);
       const { default_langage } = useContext(GlobalContext);
       let baseUrl = siteName.baseUrl;
       let defult_endpoint = siteName.training_endpoits;
       let webEndpoints = siteName.commonEndpoints;
        let country_detils =JSON.parse(localStorage.getItem('country_detils'));
   useEffect(() => {
      const fetchCountries = async () => {
        try {
          
          const response = await fetch(baseUrl + webEndpoints + 'get/all/countries');
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          console.log(response);
          const countries = await response.json();
     console.log(countries);
          let cities = '';
          let timeZones = ''; 
    
        const updateCountries =  countries.map((country) => {
      let items_country = {
              ...country,
              value: country.countryId,
              label: country.countryName,
              name: 'countryId',
               flag: 'https://flagcdn.com/w40/' + country.countryCode.toLowerCase() + '.png',
            };
            if(country.countryId == formData.countryId){
              cities = country.cities;
              timeZones = country.timeZones ?? [];
              setSelectedCountry(items_country);
            }
            
               return items_country
          
              
          });
          setOptionDatacountryDetils(updateCountries);
          setOptionDataZone(timeZones);
          console.log(cities);
          setOptionData(cities);
            let all_cities = cities.map((city) => {
             const item = {
          value: city.cityId,
          label: city.cityName,
          name: 'cityId',
          
        };
        return item;
          });
           setOptionData_all(all_cities);
            let othe_time_stus = false;
            let time_zoneid = '';
              timeZones.map((time_vl) => {
           let dtime_title = time_vl.timeZoneTitle;
           dtime_title = dtime_title.replace(/[\r\n"]/g, '').trim();
            if(timeZone_nm_dt == dtime_title){
              time_zoneid = time_vl.timeZoneId;
              othe_time_stus = true;
               
            }
          });
         
          if(othe_time_stus){
          
          }
          
          setLoading(false);
        } catch (error) {
          setError(error);
          setLoading(false);
        }
      };
    
      fetchCountries();
    }, []);

       const handleChange_other = (e) => {
        console.log(e);

        if(e.name === 'fromDate' ){
          setStartDate(e.value);
        }

        if(e.name === 'toDate' ){
          console.log('test');
          setendDate(e.value);
        }
       
        const { name, value } = e;
      
            if (name in formdata_valid_error) {
                if('validtion' in formdata_valid_error[name]){
               
                  let result = null;
                  let newformdata;
                    for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                      console.log(formdata_valid_error[name].validtion[i].methods);
                        if (methods[formdata_valid_error[name].validtion[i].methods]) {
                            result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                            }
                       if(result == false){
                        formdata_valid_error[name].error = true;
                        formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                        break;
                       }
                       if(result == true){
                        
                          formdata_valid_error[name].error = false;
                        formdata_valid_error[name].errormsg = null;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                       }
    
                }
                
                }
     
            }
          
            setFormData(prev => ({
              ...prev,
              [name]: value
            }));
            console.log(formData)
          };
       const handleChange = (e) => {
        console.log(e);
                let name, value;

if ("label" in e) {
  ({ name, value } = e);
} else {
  ({ name, value } = e.target);
}
            
          
        
            if(name == "countryId"){
              let timeZones;
              let cities;
            
                     countryDetils_dt.map((country) => {
            if(country.countryId == value){
            
              cities = country.cities;
              timeZones = country.timeZones ?? [];
              setSelectedCountry(country);
            }
          
          
              
          });
            setOptionDataZone(timeZones);
          setOptionData(cities);
        
            let all_cities = cities.map((city) => {
             const item = {
          value: city.cityId,
          label: city.cityName,
          name: 'cityId',
          
        };
        return item;
          });
           setOptionData_all(all_cities);
                  setFormData(prev => ({
              ...prev,
              cityId: ''
            }));
          let time_vlue_other = '';
          settimezone_stus(false);
          timeZones.map((time_vl) => {
           let dtime_title = time_vl.timeZoneTitle;
           dtime_title = dtime_title.replace(/[\r\n"]/g, '').trim();
            if(timeZone_nm_dt == dtime_title){
              time_vlue_other = time_vl.timeZoneId.toString();
               settimezone_stus(true);
            }
          });
          setSelectedCity(null);
         
      
            }

            if(name == 'cityId'){
              setSelectedCity(e);
            }
        
            if (name in formdata_valid_error) {
                if('validtion' in formdata_valid_error[name]){
               
                  let result = null;
                  let newformdata;
                    for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                        if (methods[formdata_valid_error[name].validtion[i].methods]) {
                            result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                            }
                       if(result == false){
                        formdata_valid_error[name].error = true;
                        formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                        break;
                       }
                       if(result == true){
                        
                          formdata_valid_error[name].error = false;
                        formdata_valid_error[name].errormsg = null;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                       }
    
                }
                
                }
     
            }
          
            setFormData(prev => ({
              ...prev,
              [name]: value
            }));
           
          };

               const handleSubmit = (e) => {
                  e.preventDefault(); 
                  let value;
                     loader.classList.remove('d-none');
                  for (const name in formData) {
                      value = formData[name];
                      if (name in formdata_valid_error) {
                      if('validtion' in formdata_valid_error[name]){
                     
                        let result = null;
                        let newformdata;
                          for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                               console.log(formdata_valid_error[name].validtion[i].methods);
                               console.log(name);
                              if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                  result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                  }else{
                                    console.log('tewerwr')
                                    result = true;
                                  }
                             if(result == false){
                              formdata_valid_error[name].error = true;
                              formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                              break;
                             }
                             if(result == true){
                              
                                formdata_valid_error[name].error = false;
                              formdata_valid_error[name].errormsg = null;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                             }
          
                      }
                      
                      }
           
                  }
                      }
          
                      let validation = true;
                       for (const key in formdata_valid_error) {
                          if(formdata_valid_error[key].error == true){
                             validation = false; 
                             loader.classList.add('d-none');
                             break;
                          }
                       }
          
                       if(validation){
                       let validation_stus = isValidDateRange(formData.fromDate,formData.fromDate.toDate);
                            console.log(validation_stus);         
                          console.log('Form submitted:', 'success');
                          console.log('Form submitted:', formData);
                        handleSubmit_axios(formData);
                          
                       }else{
                          loader.classList.add('d-none'); 
                          console.log('Form submitted:', 'faild');
                          console.log('Form submitted:', formdata_valid_error);
                       } 
                };

                const handleSubmit_axios = async (formData) => {
      
        try {
      
        //  const response = await axios.post(baseUrl+defult_endpoint+'register/student', formData);
 const token =  localStorage.getItem('token');
          let formdata_submit = formData
                  formdata_submit.cityId = parseInt(formData.cityId);
          formdata_submit.cost = parseInt(formData.cost);

            const response = await axios.post(baseUrl+'web/v1/create/training/session/end/date', formdata_submit,{
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
          let data = response;
          console.log(data);

          /*call back data*/
        setFormData({
           fromDate: '',
            startTime: starttime,
           endTime: endDate,
           title: '',
           cost:'',
           cityId:'',
           address:'',
           countryId: localStorage.getItem('default_country_code'),
           languageField:default_langage_details.label,
           campaignCode:''
   
         });
      if(data.status){
        loader.classList.add('d-none');
        setSetshowThanks(false);
      }
      //window.location.reload();
         
        } catch (error) {
            loader.classList.add('d-none');
            if ("data" in error.response) {
          setErrormsg(error.response.data.message);
            }
          
        
          console.log(error.response.data);
          /*error call back*/
        //  window.location.reload();
         // logout_action();
        }
      
    };
     const { setLogin } = useContext(GlobalContext);
    const logout_action = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('loginbefore');
      localStorage.removeItem('role');
      setLogin(false);
    refreshApp();
    //   window.location.replace(window.location.href);
    };

    const cleanString = (value,v_id,timeZone_nm_dt_detil) => {
     
        let lest_vlue = value
          .replace(/[\r\n"]/g, '') 
          .trim(); 

   
    return lest_vlue;               
}

   const formatOptionLabel = ({ label, flag }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={flag} alt="" style={{ width: 26, marginRight: 10,border: "1px solid #ddd" }} />
          {label}
        </div>
      );

      const customStyles = {
      control: (provided) => ({
        ...provided,
           height: '45px',
           lineHeight: '0',
           minHeight: '45px',
        
      })
    };
   
    
return (
       <section className="cfan-form-section">
        <div class="container">
       {showThanks? <form onSubmit={handleSubmit}>
            <div class="heading-form">
                <h3>{t('Create_Training_Sessions')}</h3>
            </div>
              {errormsg != null? <div className='error_global error error-trinercreate'>{errormsg}</div> : ''}
            <div class="form-items-wrapper">
                <div class="form-intem">
                    <label htmlFor="fdate">{t('From_Date')}(MM-DD-YYYY){formdata_valid_error.fromDate.required? <span>*</span> : ''}</label>
                      <DatePicker selected={ startDate
      ? parseYYYYMMDDToDate(startDate)
      : null} onChange={(date) => handleChange_other({ value: formatDateYYYYMMDD(date),  name: "fromDate",  label: formatDateMMDDYYYY(date)  }) } 
                           dateFormat="MM-dd-yyyy"
                           placeholderText="MM-DD-YYYY"
                          isClearable
                          minDate={new Date()}
                          showYearDropdown
                          scrollableMonthYearDropdown
                          style={{ display: "block" }}
                        />
                       {formdata_valid_error.fromDate.error? <div className="error">{formdata_valid_error.fromDate.errormsg}</div> : ''}
                </div>
         
                  {isSafari?    <div class="form-intem">
                    <label htmlFor="fdate">{t('Start_Time')}{formdata_valid_error.startTime.required? <span>*</span> : ''}</label>
                
                <Select 
                styles={customStyles}
                        options={timeOptions}
                        value={timeOptions.find(t => t.value === time)}
                        onChange= {handleChange_other}
                        placeholder="Select time"
                      />
        

<input type="hidden" name="startTime" value={time} />
                  {formdata_valid_error.startTime.error? <div className="error">{formdata_valid_error.startTime.errormsg}</div> : ''}
                </div>: <div class="form-intem">
                    <label htmlFor="fdate">{t('Start_Time')}{formdata_valid_error.startTime.required? <span>*</span> : ''}</label>
                     <input type="time" onChange={handleChange}  name="startTime" id="fdate" placeholder={t("Start_Time")} />
                  {formdata_valid_error.startTime.error? <div className="error">{formdata_valid_error.startTime.errormsg}</div> : ''}
                </div>}
                {isSafari? 
                   <div class="form-intem">
                    <label htmlFor="fdate">{t('End_Time')}{formdata_valid_error.endTime.required? <span>*</span> : ''}</label>
                   <Select
          styles={customStyles}
        options={timeOptions_end}
        value={timeOptions_end.find(t => t.value === timeend)}
         onChange= {handleChange_other}
        placeholder="Select time"
      />
      <input type="hidden"  name="endTime" value={timeend} />
                  {formdata_valid_error.endTime.error? <div className="error">{formdata_valid_error.endTime.errormsg}</div> : ''}
                </div> :      <div class="form-intem">
                    <label htmlFor="fdate">{t('End_Time')}{formdata_valid_error.endTime.required? <span>*</span> : ''}</label>
                     <input type="time" onChange={handleChange}  name="endTime" id="endTime" placeholder={t("End_Time")} />
                  {formdata_valid_error.endTime.error? <div className="error">{formdata_valid_error.endTime.errormsg}</div> : ''}
                </div> }
          
                <div class="form-intem">
                    <label htmlFor="titles">{t("Title")}{formdata_valid_error.title.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="title" id="titles" placeholder={t('Enter_title')} />
                    {formdata_valid_error.title.error? <div className="error">{formdata_valid_error.title.errormsg}</div> : ''}
                </div>
                     <div class="form-intem">
                    <label htmlFor="costs">{t("Cost")}{formdata_valid_error.cost.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="cost" id="costs" placeholder={t('Enter_your_cost')} />
                 {formdata_valid_error.cost.error? <div className="error">{formdata_valid_error.cost.errormsg}</div> : ''}

                </div>
                <div class="form-intem">
                    <label htmlFor="country">{t("select_country")}</label>
                         <Select
                                                styles={customStyles}
                                                options={countryDetils_dt}
                                                name="countryId"
                                                value={selectedCountry}
                                                onChange={handleChange}
                                                placeholder="Select a country..."
                                                isSearchable  
                                                  formatOptionLabel={formatOptionLabel}  />
                     
                </div>
                {cityoptions?.length > 0 && (
                         
                         
                  <div class="form-intem">
                    <label htmlFor="country">{t("city")}</label>
                        <Select
                                                styles={customStyles}
                                                options={cityoptionsall}
                                                name="cityId"
                                                value={selectedCity}
                                                onChange={handleChange}
                                                placeholder="Select a city..."
                                                isSearchable    />
                
                       
                </div> )}
                <div class="form-intem">
                    <label htmlFor="addrs">{t("Address")}{formdata_valid_error.address.required? <span>*</span> : ''}</label>
                    <textarea name="address" onChange={handleChange} ></textarea>
                    {formdata_valid_error.address.error? <div className="error">{formdata_valid_error.address.errormsg}</div> : ''} 
                </div>
                    <div class="form-intem">
                    <label htmlFor="titles">{t("campaignCode")}{formdata_valid_error.campaignCode.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="campaignCode" id="campaignCode" placeholder={t("Enter_campaignCode")} />
                    {formdata_valid_error.campaignCode.error? <div className="error">{formdata_valid_error.campaignCode.errormsg}</div> : ''}
                </div>
           
                <div class="form-intem form-item-full">
                    <button type="submit">{t("Submit")}</button>
                </div>
            </div>
        </form> : <div className="form-submit-success">
                              {t('New_session_created_successfully')}
                            </div>  }
    </div>
</section>
  );
};

export default Body;